<template>
  <!-- latest section -->
  <section class="services-section latest-section blog-section-three">
    <div class="container">
      <div class="services-header aos" data-aos="fade-up">
        <div class="row">
          <div class="col-md-12">
            <div class="section-content">
              <h2>Our Latest News</h2>
              <div class="our-img-all-1">
                <img src="@/assets/img/icons/cuttor-small.svg" alt="Scissor">
              </div>
              <p>
                Our Barbershop & Tattoo Salon provides classic services combined with
                innovative techniques.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-12">
          <div class="owl-carousel latest-slider aos" data-aos="fade-up">
            <Carousel :wrap-around="true" :settings="settings" :breakpoints="breakpoints">
              <Slide v-for="item in indexthreelatest" :key="item.id">
                <div class="blog blog-new flex-fill">	
                  <div class="blog-image">
                    <router-link to="/blogs/blog-details"><img class="img-fluid"
                      :src="require(`@/assets/img/services/${item.image}`)" alt="Post Image"></router-link>
                      <div class="date">
                        15
                        <span>Nov 2023</span>
                      </div>
                  </div>
                  <div class="blog-content mb-0 text-start">
                    <div class="blog-category">
                      <ul>
                        <li>
                          <a href=""><span class="cat-blog">Hair Cut</span></a>
                        </li>
                        <li>
                          <a href=""><span class="cat-blog">Facial</span></a>
                        </li>
                      </ul>
                    </div>
                    <h3 class="blog-title">
                      <router-link to="/blogs/blog-details">
                        {{item.title}}
                      </router-link>
                    </h3>
                    <div class="blog-view d-flex">
                      <router-link to="/blogs/blog-details"
                        class="btn btn-light d-flex w-100 justify-content-center text-dark">Read
                        More</router-link>
                    </div>
                  </div>
                </div>
              </Slide>
              <template #addons>
                <Navigation />
              </template>
            </Carousel>
          </div>
        </div>
      </div>
    </div>
  </section>
  <!-- /latest section -->

  <!-- register section -->
  <section class="register-section aos" data-aos="fade-up">
    <div class="container">
      <div class="row">
        <div class="col-lg-12 col-12">
          <div class="register-content register-content-four">
            <h2>Get Registered and List your Saloon for free!!!</h2>
            <div class="register-btn">
              <router-link to="/register"><i class="feather-users me-2"></i>Register Now</router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
<!--/register section  -->
</template>

<script>
import { Carousel, Pagination, Navigation, Slide } from "vue3-carousel";
import indexthreelatest from "@/assets/json/indexthreelatest.json";
import "vue3-carousel/dist/carousel.css";
export default {
  data() {
    return {
      indexthreelatest: indexthreelatest,
      settings: {
        itemsToShow: 1,
        snapAlign: "center",
        loop: true,
        margin: 24,
      },

      breakpoints: {
        575: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 700px and up
        767: {
          itemsToShow: 1,
          snapAlign: "center",
        },
        // 991px and up
        991: {
          itemsToShow: 3,
          snapAlign: "center",
        },
        // 1024 and up
        1024: {
          itemsToShow: 4,
          snapAlign: "start",
        },
      },
    };
  },
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },
};
</script>
